import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ICommodityTypeFormResult } from '../../../models/commodity-type/interfaces';
import { DIALOG_HIDE_CLASS } from '../../shared/constants';
import { RanchCommodityTypeFormComponent } from '../../ranch-settings/shared/ranch-commodity-type-form/main';

@Component({
	moduleId: module.id,
	selector: 'ranch-create-commodity-type-dialog',
	templateUrl: 'commodity-type-dialog.html'
})

export class RanchCreateCommodityTypeDialog implements OnDestroy {
	@ViewChild(RanchCommodityTypeFormComponent, { static: false })
	public commodityTypeForm: RanchCommodityTypeFormComponent;

	private _subscriptions$: Subject<boolean>;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: {
			commodityType?: ICommodityTypeFormResult,
			selectedCommodityTypeIds: number[]
		},
		private _dialogRef: MatDialogRef<RanchCreateCommodityTypeDialog>
	) {
		this._subscriptions$ = new Subject();

		this._dialogRef.backdropClick()
			.pipe(takeUntil(this._subscriptions$)).subscribe(() => {
				this.close();
			});
	}

	public ngOnDestroy(): void {
		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public close(): void {
		if (!this.commodityTypeForm) {
			this.closeFinal();
			return;
		}

		this.commodityTypeForm.cancel();
	}

	public closeFinal(): void {
		this._dialogRef.close();
	}

	public hide(): void {
		this._dialogRef.addPanelClass(DIALOG_HIDE_CLASS);
	}

	public show(): void {
		this._dialogRef.removePanelClass(DIALOG_HIDE_CLASS);
	}

	public submit(result: ICommodityTypeFormResult): void {
		this._dialogRef.close(result);
	}
}
